module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadSearch'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list-box"
  }, _vm._l((_vm.cate_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cate-items",
      on: {
        "click": function($event) {
          return _vm.onNavClick(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "mode": "widthFix",
        "src": item.pic_url
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "12px",
        "color": "#333",
        "margin-top": "10px"
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('van-sticky', {
    attrs: {
      "offset-top": 40
    }
  }, [_c('div', {
    staticClass: "goods-type"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-top": "0.2rem"
    }
  }, [_c('van-tabs', {
    staticClass: "tabs_",
    attrs: {
      "line-height": "0",
      "line-width": _vm.width
    },
    on: {
      "click": _vm.getCateGoods
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.cate_list), function(item, i) {
    return _c('van-tab', {
      key: item.id,
      staticClass: "tab_"
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "tagname show-one-row"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      class: _vm.active == i ? 'sname-change show-one-row' : 'sname show-one-row'
    }, [_vm._v(_vm._s(item.sname))])])], 2)
  }), 1)], 1)])]), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('div', {
    staticClass: "goods-list"
  }, [_c('GoodsItems', {
    attrs: {
      "goodsList": _vm.goods
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa32773e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/goods/GoodsList.vue
// module id = 2635
// module chunks = 0